export default __webpack_public_path__ + "static/media/track-location-animation.3592d9ec.gif";